import type { CHARGE_STATUS_ENUM } from '@woovi/shared';

import type { PLUGIN_TYPE } from '../PluginType.ts';
import { createStore } from '../store/createStore.tsx';

export const initialState = {
  isOpen: false,
  brCode: null,
  chargeID: null,
  value: null,
  description: null,
  correlationID: null,
  config: {
    appID: null,
  },
  additionalInfo: [],
  expiresIn: null,
  user: null,
  modal: true,
  type: null,
  availablePaymentMethods: null,
};

export const getInitialState = () => {
  return initialState;
};

export type OpenPixStoreUser = {
  name: string;
  email: string;
  taxID: string;
  phone: string;
};

export type OpenPixStoreCustomer = {
  name: string;
  email: string;
  taxID: string;
  phone: string;
};

export type AdditionalInfoItem = {
  key: string;
  value: string;
};

export type OpenPixStoreState = {
  isOpen: boolean; // whether the qrcode dialog is opened or not
  brCode: string | null; // current brCode to be render as qrcode
  chargeID: string | null; // charge id to listen to
  shopperId: string | null; // charge id to listen to
  value: number | null; // value of this charge
  description: string | null; // description of this charge
  correlationID: string | null; // correlationID of this charge
  config: {
    // openpix appid key
    appID: string | null;
  };
  additionalInfo: AdditionalInfoItem[];
  expiresIn: number | null; // expiresIn of this charge
  user: OpenPixStoreUser | null; // openpix user
  customer: OpenPixStoreCustomer | null; // openpix customer
  success: boolean; // whether this payment was a success
  closeOnSuccess: boolean;
  identifier: string;
  status: keyof typeof CHARGE_STATUS_ENUM;
  expiration: number;
  createdAt: string | Date;
  me: any;
  company: {
    id: string;
    name: string;
    nameFriendly: string;
  };
  installmentsNumber: number;
  isTemp: boolean;
  pluginType: keyof typeof PLUGIN_TYPE;
  enableCashbackPercentage?: boolean;
  enableCashbackExclusivePercentage?: boolean;
  modal?: boolean;
  alwaysShowQrCode?: boolean;
  allowSimulatePayment?: boolean;
  availablePaymentMethods?: string[];
  type?: string;
};

export const store = createStore<OpenPixStoreState>();
